/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  EventsContainer,
  MainEventsContainer,
  CompletedChallengeWrapper,
  //StyledSvgNew,
} from "./styles";
import { NoComments } from "../SocialFeeds/styles";
import SingleEvent from "./SingleEventV2";
import { withTranslation } from "react-i18next";
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import { BuddyTabContainer } from "../PeopleHomeV2/styles";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { ToolTipNew } from "../AdminTeamCreation/styles";
import { connect } from "react-redux";
import { getEventsPoints } from "../../redux/actions";
import SkeletonLoder from "../common/skeletonLoder";
import {BuddyTab} from '../common/commonStyles';
import { NewScheduledEventIcon } from "../../utils/icons";

class CompletedEvents extends Component {
  constructor() {
    super();
    this.state = {
      pageNumber: 1,
      eventCreate: false,
      ondemandCreate: false,
      scheduledEvents: false
    };
  }

  componentDidMount() {
    const { fetchPastEvents } = this.props;
    fetchPastEvents();
  }

  onScroll = (e, events) => {
    const { pageNumber } = this.state;
    const { loadMoreEvents, totalCount } = this.props;
    const bottom = Math.round(e.target.scrollHeight - parseInt(e.target.scrollTop,10)) ===Math.round(e.target.clientHeight+1)||Math.round(e.target.scrollHeight - parseInt(e.target.scrollTop,10)+1) ===Math.round(e.target.clientHeight+1);
    if (events.length < totalCount) {
      if (bottom) {
        this.setState(
          {
            pageNumber: pageNumber + 1,
          },
          () => {
            loadMoreEvents(this.state.pageNumber);
          }
        );
      }
    }
  };

  eventButtonStatusHover = (value) => {
    if (value === "event")
      this.setState({
        eventCreate: true,
      });
    else if(value=="schedule"){
      this.setState({
        scheduledEvents: true,
      });
    }       
    else {
      this.setState({
        ondemandCreate: true,
      });
    }
  };

  eventButtonStatus = (value) => {
    if (value === "event")
      this.setState({
        eventCreate: false,
      });
    else if(value=="schedule"){
      this.setState({
        scheduledEvents: false,
      });
    }      
    else {
      this.setState({
        ondemandCreate: false,
      });
    }
  };

  schedule = () =>(
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.69065 11.6821C8.69065 11.894 8.50521 12.0795 8.29329 12.0795H6.80985C6.59793 12.0795 6.4125 11.894 6.4125 11.6821V10.1987C6.4125 9.98675 6.59793 9.80132 6.80985 9.80132H8.29329C8.50521 9.80132 8.69065 9.98675 8.69065 10.1987V11.6821ZM11.8165 10.1987C11.8165 9.98675 11.631 9.80132 11.4191 9.80132H9.93568C9.72376 9.80132 9.53833 9.98675 9.53833 10.1987V11.6821C9.53833 11.894 9.72376 12.0795 9.93568 12.0795H11.4191C11.631 12.0795 11.8165 11.894 11.8165 11.6821V10.1987ZM14.9423 10.1987C14.9423 9.98675 14.7569 9.80132 14.545 9.80132H13.035C12.8231 9.80132 12.6377 9.98675 12.6377 10.1987V11.6821C12.6377 11.894 12.8231 12.0795 13.035 12.0795H14.5185C14.7304 12.0795 14.9158 11.894 14.9158 11.6821V10.1987H14.9423ZM8.69065 13.2185C8.69065 13.0066 8.50521 12.8212 8.29329 12.8212H6.80985C6.59793 12.8212 6.4125 13.0066 6.4125 13.2185V14.702C6.4125 14.9139 6.59793 15.0993 6.80985 15.0993H8.29329C8.50521 15.0993 8.69065 14.9139 8.69065 14.702V13.2185ZM11.8165 13.2185C11.8165 13.0066 11.631 12.8212 11.4191 12.8212H9.93568C9.72376 12.8212 9.53833 13.0066 9.53833 13.2185V14.702C9.53833 14.9139 9.72376 15.0993 9.93568 15.0993H11.4191C11.631 15.0993 11.8165 14.9139 11.8165 14.702V13.2185ZM14.545 12.8212H13.035C12.8231 12.8212 12.6377 13.0066 12.6377 13.2185V14.702C12.6377 14.9139 12.8231 15.0993 13.035 15.0993H14.5185C14.7304 15.0993 14.9158 14.9139 14.9158 14.702V13.2185C14.9423 13.0066 14.7569 12.8212 14.545 12.8212ZM5.16747 15.8675H3.68402C3.4721 15.8675 3.28667 16.053 3.28667 16.2649V17.7483C3.28667 17.9603 3.4721 18.1457 3.68402 18.1457H5.16747C5.37939 18.1457 5.56482 17.9603 5.56482 17.7483V16.2649C5.56482 16.053 5.40588 15.8675 5.16747 15.8675ZM5.56482 13.2185C5.56482 13.0066 5.37939 12.8212 5.16747 12.8212H3.68402C3.4721 12.8212 3.28667 13.0066 3.28667 13.2185V14.702C3.28667 14.9139 3.4721 15.0993 3.68402 15.0993H5.16747C5.37939 15.0993 5.56482 14.9139 5.56482 14.702V13.2185ZM11.4191 15.8675H9.93568C9.72376 15.8675 9.53833 16.053 9.53833 16.2649V17.7483C9.53833 17.9603 9.72376 18.1457 9.93568 18.1457H11.4191C11.631 18.1457 11.8165 17.9603 11.8165 17.7483V16.2649C11.8165 16.053 11.631 15.8675 11.4191 15.8675ZM8.29329 15.8675H6.80985C6.59793 15.8675 6.4125 16.053 6.4125 16.2649V17.7483C6.4125 17.9603 6.59793 18.1457 6.80985 18.1457H8.29329C8.50521 18.1457 8.69065 17.9603 8.69065 17.7483V16.2649C8.69065 16.053 8.50521 15.8675 8.29329 15.8675ZM17.6443 12.0795C17.8562 12.0795 18.0416 11.894 18.0416 11.6821V10.1987C18.0416 9.98675 17.8562 9.80132 17.6443 9.80132H16.1608C15.9489 9.80132 15.7635 9.98675 15.7635 10.1987V11.6821C15.7635 11.894 15.9489 12.0795 16.1608 12.0795H17.6443ZM2.30654 21.404H13.6443C13.4589 20.8212 13.3529 20.2119 13.3529 19.6026H2.30654C2.01515 19.6026 1.77674 19.3642 1.77674 19.0728V8.39735H19.5516V13.3775C20.1873 13.3775 20.7966 13.4834 21.3529 13.6424V4.63576C21.3529 3.33775 20.2933 2.30464 19.0218 2.30464H16.3993V0.847682C16.3993 0.370861 16.0284 0 15.5516 0H14.2271C13.7502 0 13.3794 0.370861 13.3794 0.847682V2.30464H7.97541V0.847682C7.97541 0.370861 7.60455 0 7.12773 0H5.80323C5.32641 0 4.95555 0.370861 4.95555 0.847682V2.30464H2.33303C1.03502 2.30464 0.00190412 3.36424 0.00190412 4.63576V19.0464C-0.051076 20.3444 1.00853 21.404 2.30654 21.404ZM24.0019 19.5232C24.0019 21.9868 21.9887 24 19.5251 24C17.0615 24 15.0483 21.9868 15.0483 19.5232C15.0483 17.0596 17.0615 15.0464 19.5251 15.0464C21.9887 15.0464 24.0019 17.0596 24.0019 19.5232ZM21.7767 18.3576C21.7767 18.2252 21.7238 18.0662 21.6178 17.9868C21.4059 17.7748 21.0615 17.7748 20.8496 17.9868L18.9158 19.9205L18.1741 19.1788C17.9622 18.9669 17.6178 18.9669 17.4059 19.1788C17.2999 19.2848 17.2469 19.4172 17.2469 19.5497C17.2469 19.6821 17.2999 19.8146 17.4059 19.9205L18.5185 21.0331C18.7304 21.245 19.0748 21.245 19.2867 21.0331L21.6178 18.702C21.7238 18.649 21.7767 18.5166 21.7767 18.3576Z" fill="#9C9C9C"/>
    </svg>
  )   

  redirect=()=>{
    this.props.history.push(`/events/schedule`);
  } 


  headerView = () => {
    // const { /*eventCreate, ondemandCreate,*/scheduledEvents } = this.state;
    // const { role, isAdmin } = this.props;
    const popover = (value) => (
      <Popover
        id="popover-basic"
        style={{
          width: "auto",
          padding: "9px 14px",
          background: "#FFFFFF",
          border: "1px solid #005c87",
          boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
          borderRadius: "6px",
        }}
      >
        <div
          style={{
            fontFamily: "Rubik",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#005c87",
            textAlign: "center",
          }}
        >
          {value}
        </div>
      </Popover>
    );
    return (
      <BuddyTabContainer marginBottom="25px" style={{justifyContent:"space-between"}} pLeft="0px">
        <div style={{display:'flex',gap:'15px'}}>
          <BuddyTab
            active={false}
            padding
            onClick={() => this.props.history.push({pathname:"/events",state:"updateData"})}
            margin="auto auto auto 8px"
          >
            {this.props.t("Events")}
          </BuddyTab>
          <BuddyTab active={true} padding   margin="auto auto auto 8px">
            {" "}
            {this.props.t("Completed")}
          </BuddyTab>
        </div>
        <div style={{display:'flex'}}>
          <ToolTipNew
            width="40px"
            height="40px"
            margin={"auto 8px auto auto"}
            transparent
            // active={scheduledEvents}
            // onMouseEnter={() => this.eventButtonStatusHover("schedule")}
            // onMouseLeave={() => this.eventButtonStatus("schedule")}
          > 
            <OverlayTrigger
              placement="bottom"
              overlay={popover(this.props.t("Scheduled Events"))}
            >
              <div
                className='="toolTip'
                onClick={this.redirect}
              >
                {
                  // <StyledSvgNew active={scheduledEvents} isCompletedEvents={true} width="24px" >
                  //   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  //     <path d="M20.5909 2.6242H18.5455V1.53329C18.5455 1.24396 18.4305 0.966488 18.2259 0.761903C18.0214 0.557318 17.7439 0.442383 17.4545 0.442383C17.1652 0.442383 16.8877 0.557318 16.6832 0.761903C16.4786 0.966488 16.3636 1.24396 16.3636 1.53329V2.6242H13.0909V1.53329C13.0909 1.24396 12.976 0.966488 12.7714 0.761903C12.5668 0.557318 12.2893 0.442383 12 0.442383C11.7107 0.442383 11.4332 0.557318 11.2286 0.761903C11.024 0.966488 10.9091 1.24396 10.9091 1.53329V2.6242H7.63636V1.53329C7.63636 1.24396 7.52143 0.966488 7.31684 0.761903C7.11226 0.557318 6.83478 0.442383 6.54545 0.442383C6.25613 0.442383 5.97865 0.557318 5.77407 0.761903C5.56948 0.966488 5.45455 1.24396 5.45455 1.53329V2.6242H3.40909C2.5053 2.62536 1.63885 2.9849 0.999775 3.62398C0.360696 4.26305 0.00115464 5.1295 0 6.03329V9.16966H24V6.03329C23.9988 5.1295 23.6393 4.26305 23.0002 3.62398C22.3611 2.9849 21.4947 2.62536 20.5909 2.6242Z" fill="#007AB1"/>
                  //     <path fillRule="evenodd" clipRule="evenodd" d="M0 21.0334C0.00115464 21.9372 0.360696 22.8036 0.999775 23.4427C1.63885 24.0818 2.5053 24.4413 3.40909 24.4425H20.5909C21.4947 24.4413 22.3611 24.0818 23.0002 23.4427C23.6393 22.8036 23.9988 21.9372 24 21.0334V11.3516H0V21.0334ZM12 13.397C12.5523 13.397 13 13.8447 13 14.397V16.897H15.5C16.0523 16.897 16.5 17.3447 16.5 17.897C16.5 18.4493 16.0523 18.897 15.5 18.897H13V21.397C13 21.9493 12.5523 22.397 12 22.397C11.4477 22.397 11 21.9493 11 21.397V18.897H8.5C7.94772 18.897 7.5 18.4493 7.5 17.897C7.5 17.3447 7.94772 16.897 8.5 16.897H11V14.397C11 13.8447 11.4477 13.397 12 13.397Z" fill="#007AB1"/>
                  //   </svg>
                  // </StyledSvgNew>
                  <NewScheduledEventIcon/>
                }
              </div>
            </OverlayTrigger>
          </ToolTipNew>
          {/* {role === "ADMIN" && (
            <ToolTipNew
              margin={"auto 8px auto 8px"}
              width="40px"
              height="40px"
              active={eventCreate}
              onMouseEnter={() => this.eventButtonStatusHover("event")}
              onMouseLeave={() => this.eventButtonStatus("event")}
            >
              <OverlayTrigger
                placement="bottom"
                overlay={popover(this.props.t("Create On-Demand Event"))}
              >
                <div
                  className='="toolTip'
                  onClick={() =>
                    this.props.history.push(`/events/create-ondemand`)
                  }
                >
                  {
                    <StyledSvgNew active={eventCreate} width="24px" height="24px">
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                        <path d="M23.5334 6.05056C23.245 5.89117 22.9193 5.81173 22.59 5.82045C22.2607 5.82916 21.9397 5.92572 21.6602 6.10014L18.0228 8.37267V6.46161C18.022 5.72741 17.73 5.02351 17.2109 4.50436C16.6917 3.9852 15.9878 3.69318 15.2536 3.69238H3.25361C2.51941 3.69318 1.81551 3.9852 1.29635 4.50436C0.777191 5.02351 0.485176 5.72741 0.484375 6.46161V17.5385C0.485176 18.2727 0.777191 18.9766 1.29635 19.4958C1.81551 20.015 2.51941 20.307 3.25361 20.3078H15.2536C15.9878 20.307 16.6917 20.015 17.2109 19.4958C17.73 18.9766 18.022 18.2727 18.0228 17.5385V15.6275L21.6602 17.9C21.9396 18.0748 22.2607 18.1715 22.5902 18.1802C22.9197 18.1889 23.2455 18.1092 23.5337 17.9494C23.822 17.7896 24.0621 17.5555 24.2293 17.2715C24.3965 16.9874 24.4846 16.6638 24.4844 16.3342V7.66594C24.4843 7.33634 24.3961 7.01275 24.2289 6.72872C24.0617 6.44468 23.8215 6.21054 23.5334 6.05056Z" fill="#007AB1"/>
                        <path d="M9.40137 8.5L9.40137 15.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M5.90137 12L12.9014 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </StyledSvgNew>
                  }
                </div>
              </OverlayTrigger>
            </ToolTipNew>
          )}
          {isAdmin && (
            <ToolTipNew
              margin={role === "ADMIN" ? "auto 8px auto 8px" : "auto 8px auto 8px"}
              width="40px"
              height="40px"
              active={ondemandCreate}
              onMouseEnter={() => this.eventButtonStatusHover("ondemand")}
              onMouseLeave={() => this.eventButtonStatus("ondemand")}
            >
              <OverlayTrigger
                placement="bottom"
                overlay={popover(this.props.t("Create Event"))}
              >
                <div
                  className='="toolTip'
                  onClick={() => this.props.history.push(`/company/events/create`)}
                >
                  <StyledSvgNew active={ondemandCreate}  width="24px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                      <path d="M21.0753 2.18182H19.0298V1.09091C19.0298 0.801582 18.9149 0.524105 18.7103 0.31952C18.5057 0.114935 18.2282 0 17.9389 0C17.6496 0 17.3721 0.114935 17.1675 0.31952C16.9629 0.524105 16.848 0.801582 16.848 1.09091V2.18182H13.5753V1.09091C13.5753 0.801582 13.4603 0.524105 13.2558 0.31952C13.0512 0.114935 12.7737 0 12.4844 0C12.195 0 11.9176 0.114935 11.713 0.31952C11.5084 0.524105 11.3935 0.801582 11.3935 1.09091V2.18182H8.12074V1.09091C8.12074 0.801582 8.0058 0.524105 7.80122 0.31952C7.59663 0.114935 7.31916 0 7.02983 0C6.7405 0 6.46303 0.114935 6.25844 0.31952C6.05386 0.524105 5.93892 0.801582 5.93892 1.09091V2.18182H3.89347C2.98967 2.18297 2.12323 2.54251 1.48415 3.18159C0.845071 3.82067 0.48553 4.68712 0.484375 5.59091V8.72727H24.4844V5.59091C24.4832 4.68712 24.1237 3.82067 23.4846 3.18159C22.8455 2.54251 21.9791 2.18297 21.0753 2.18182Z" fill="#007AB1"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M0.484375 20.591C0.48553 21.4948 0.845071 22.3612 1.48415 23.0003C2.12323 23.6394 2.98967 23.9989 3.89347 24.0001H21.0753C21.9791 23.9989 22.8455 23.6394 23.4846 23.0003C24.1237 22.3612 24.4832 21.4948 24.4844 20.591V10.9092H0.484375V20.591ZM12.4844 12.9547C13.0367 12.9547 13.4844 13.4024 13.4844 13.9547V16.4547H15.9844C16.5367 16.4547 16.9844 16.9024 16.9844 17.4547C16.9844 18.0069 16.5367 18.4547 15.9844 18.4547H13.4844V20.9547C13.4844 21.5069 13.0367 21.9547 12.4844 21.9547C11.9321 21.9547 11.4844 21.5069 11.4844 20.9547V18.4547H8.98438C8.43209 18.4547 7.98438 18.0069 7.98438 17.4547C7.98438 16.9024 8.43209 16.4547 8.98438 16.4547H11.4844V13.9547C11.4844 13.4024 11.9321 12.9547 12.4844 12.9547Z" fill="#007AB1"/>
                    </svg>
                  </StyledSvgNew>
                </div>
              </OverlayTrigger>
            </ToolTipNew>
          )} */}
        </div>
      </BuddyTabContainer>
    );
  };

  render() {
    const { pastEvents, t, attendEvent, isAdmin} = this.props;
    if (
      !pastEvents ||
      isUndefined(pastEvents) ||
      isNull(pastEvents) ||
      isNull(attendEvent) ||
      isUndefined(attendEvent)
    ) {
      return <div style={{width:"1246px", margin:'auto'}}>
        <SkeletonLoder width={"100%"} height={"60px"} style={{marginTop:"25px"}}/>
        <div width={"1246px"} height={"354px"} style={{margin:"auto", marginTop:'25px',display:'flex',gap:'25px'}}> 
          <div style={{display:'flex', gap:"25px",width:'836px'}}>
            <SkeletonLoder width={"399px"} height={"334px"}/>
            <SkeletonLoder width={"399px"} height={"334px"}/>
          </div>
          <div style={{width:'385px'}}>
            <SkeletonLoder width={"100%"} height={"21px"} style={{marginBottom:"15px"}}/>
            <SkeletonLoder width={"100%"} height={"140px"} style={{marginBottom:"15px"}}/>
            <SkeletonLoder width={"100%"} height={"60px"} style={{marginBottom:"10px"}}/>
            <SkeletonLoder width={"100%"} height={"60px"} style={{marginBottom:"10px"}}/>
            <SkeletonLoder width={"100%"} height={"60px"} style={{marginBottom:"10px"}}/>
            <SkeletonLoder width={"100%"} height={"60px"} style={{marginBottom:"10px"}}/>
          </div>
        </div>
      </div>;
    }
    return (
      <MainEventsContainer marginTop="1">
        <div>
          {this.headerView()}
          <CompletedChallengeWrapper
            overflow
            height
            onScroll={(e) => this.onScroll(e, pastEvents)}
          >
            <div className="challengeCard">
              <EventsContainer>
                {!isAdmin ? (
                  pastEvents.length > 0 && pastEvents.some((event) => event.is_attended === 1) ? (
                    pastEvents
                      .filter((event) => event.is_attended === 1)
                      .map((event, index) => (
                        <SingleEvent
                          event={event}
                          history={this.props.history}
                          key={index}
                          attendEvent={this.props.attendEvent}
                          length={index}
                        />
                      ))
                  ) : (
                    <NoComments>{ (pastEvents?.length == 0 && !this.props.isLoading) && t("Currently there are no events")}.</NoComments>
                  )
                ) : (
                  pastEvents.length > 0 ?
                    pastEvents.map((event, index) => (
                      <SingleEvent
                        event={event}
                        history={this.props.history}
                        key={index}
                        attendEvent={this.props.attendEvent}
                        length={index}
                      />
                    )) : (
                      (pastEvents?.length == 0 && !this.props.isLoading) && <NoComments>{t("Currently there are no events")}.</NoComments>
                    )
                )}
              </EventsContainer>
            </div>
          </CompletedChallengeWrapper>
        </div>
      </MainEventsContainer>
    );
  }
}

CompletedEvents.propTypes = {
  history: PropTypes.object.isRequired,
  attendEvent: PropTypes.func.isRequired,
  pastEvents: PropTypes.array.isRequired,
  t: PropTypes.func,
  loadMoreEvents: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  role: PropTypes.string,
  isAdmin: PropTypes.bool.isRequired,
  eventsDetailsPoints: PropTypes.array,
  getEventsPoints: PropTypes.func,
  fetchPastEvents: PropTypes.func,
  isLoading: PropTypes.bool
};

const mapStateToProps = (state) => ({
  eventsDetailsPoints: state.profileData.eventsDetailsPoints,
});

const mapDispatchToProps = (dispatch) => ({
  getEventsPoints: () => dispatch(getEventsPoints()),
});

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(CompletedEvents));
